const dashboardShades = [
  '#2E7D32', // Green - strong, natural, stands out
  '#FF8F00', // Amber - warm, vibrant
  '#4527A0', // Deep purple - rich, modern
  '#D84315', // Deep orange - energetic, contrasts well
  '#00695C', // Teal - cool, fresh
  '#F9A825', // Yellow - bright, attention-grabbing
  '#0277BD', // Light blue - harmonious, but not brand blue
  '#AD1457', // Muted pink - soft accent
  '#283593', // Indigo - deep, elegant
  '#00838F', // Cyan - cool accent
  '#558B2F', // Light green - fresh, natural
  '#EF6C00', // Orange - bold, warm
  '#4E342E', // Brown - earthy, neutral
  '#424242', // Gray - neutral, modern
  '#37474F', // Blue gray - subtle, sophisticated
  '#9E9D24', // Lime - lively, energetic
  '#C62828', // Red - strong accent
  '#6A1B9A', // Purple - playful, creative
  '#BDBDBD', // Light gray - soft, neutral
  '#80CBC4', // Soft teal - gentle accent
];

const shadeDefault = dashboardShades;

export { dashboardShades, shadeDefault };
